import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const RedirectToCipPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const targetUrl = useMemo(() => {
    const redirectUri = searchParams.get('redirectUri');
    if (!redirectUri) return '';

    const token = localStorage.getItem('authToken');
    if (!token) return '';

    const passthrough = new URLSearchParams();
    searchParams.forEach((value, key) => {
      if (key !== 'redirectUri') passthrough.set(key, value);
    });

    passthrough.set('token', token);

    const joiner = redirectUri.includes('?') ? '&' : '?';
    return `${redirectUri}${joiner}${passthrough.toString()}`;
  }, [searchParams]);

  useEffect(() => {
    const redirectUri = searchParams.get('redirectUri');
    const token = localStorage.getItem('authToken');

    if (!redirectUri) {
      setError('Missing redirectUri parameter.');
      return;
    }

    if (!token) {
      const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
      navigate(`/login?returnTo=${returnTo}`, { replace: true });
      return;
    }

    if (targetUrl) {
      window.location.replace(targetUrl);
    }
  }, [navigate, searchParams, targetUrl]);

  return (
    <div style={{ padding: '2rem', maxWidth: 640, margin: '0 auto', textAlign: 'center' }}>
      <h2>Connecting to CIP</h2>
      {error ? <p style={{ color: '#b91c1c' }}>{error}</p> : <p>Preparing secure handoff from RS-Education...</p>}
    </div>
  );
};

export default RedirectToCipPage;
